export { Payments } from './Payments';
export { Form } from './Form';
export { Tabs } from './Tabs';
export { InfoFaq } from './InfoFaq';
export { MinMax } from './MinMax';
export { Footer } from './Footer';
export { BottomPlate } from './BottomPlate';
export { DepositBanner } from './Banner';
